import { Row, Col } from 'react-bootstrap';

function OpeningHours () {
    return (
        <div className='align-self-center'>
            <Row>
                <Col className='text-center py-3'>
                    <h2>Wir sind für Sie da!</h2>
                    <h4>Mo - Fr</h4>
                    <p>7:45–17:00 Uhr</p>
                    <h4>Samstags</h4>
                    <p>7:45–12:45 Uhr</p>
                </Col>
            </Row>
            <Row>
                <Col className='text-center py-3'>
                    <h2>Geänderte Öffnungszeiten!</h2>
                    <h4>30. & 31.05.2025</h4>
                    <p>haben wir geschlossen</p>
                </Col>
            </Row>
            <Row>
                <Col className='text-center py-3'>
                    <h4>Sie erreichen uns unter</h4>
                        <p>
                            <a className="text-decoration-none" href="tel:+49242198750">02421 98750</a><br />
                            <a href="mailto:info@heinrich-heiden.de">info@heinrich-heiden.de</a>
                        </p>
                    
                </Col>
            </Row>
        </div>
    )
}

export default OpeningHours;